import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import TheSmoke from './components/TheSmoke';
import InOutscape from './components/InOutscape';
import MutatingWonders from './components/MutatingWonders';
import UndoRedo from './components/UndoRedo';
import Exhibitions from './components/Exhibitions';
import Projects from './components/Projects';
import ProjectDetail from './components/ProjectDetail';
import ResidencyInvitation from './components/ResidencyInvitation';
import MainNavigation from './components/navigation/MainNavigation';
import { Global, css } from '@emotion/react';
import { projects } from './data/projects';
import { getMetaForPath, updatePageMeta } from './utils/pageMeta';

const globalStyles = css`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    /* Mobile-first: prevent horizontal scroll, enable smooth touch */
    overflow-x: hidden;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }

  body {
    font-family: Arial, 'Open Sans', Lato, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #fff;
    color: #000;
    line-height: 1.6;
    /* Mobile-first: 16px base prevents zoom on focus in iOS */
    font-size: 16px;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  /* Touch-friendly: min 44x44px tap target */
  a, button {
    touch-action: manipulation;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  p {
    margin-bottom: 1.5em;
  }

  @media print {
    nav {
      display: none !important;
    }
  }
`;

const AppContent = () => {
  const location = useLocation();
  const isInvitationPage = location.pathname.includes('/invitation');

  useEffect(() => {
    const projectMatch = location.pathname.match(/^\/projects\/([^/]+)/);
    const project = projectMatch
      ? projects.find((p) => p.id === projectMatch[1])
      : undefined;
    const meta = getMetaForPath(location.pathname, project?.title);
    updatePageMeta(meta);
  }, [location.pathname]);

  return (
    <>
      <Global styles={globalStyles} />
      {!isInvitationPage && <MainNavigation />}
      <Routes>
        <Route path="/" element={<Exhibitions />} />
        <Route path="/exhibitions/the-smoke" element={<TheSmoke />} />
        <Route path="/exhibitions/the-smoke/:artistId?" element={<TheSmoke />} />
        <Route path="/exhibitions/mutating-wonders" element={<MutatingWonders />} />
        <Route path="/exhibitions/mutating-wonders/:artistId?" element={<MutatingWonders />} />
        <Route path="/exhibitions/in-outscape" element={<InOutscape />} />
        <Route path="/exhibitions/in-outscape/:artistId?" element={<InOutscape />} />
        <Route path="/exhibitions/undo-redo" element={<UndoRedo />} />
        <Route path="/exhibitions/undo-redo/:artistId?" element={<UndoRedo />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectId" element={<ProjectDetail />} />
        <Route 
          path="/projects/:projectId/invitation" 
          element={<ResidencyInvitation project={projects[0]} />} 
        />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
